import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import { Provider } from "react-redux";
import { store, persistor } from "./store";
import "./App.css";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import HomeSearch from "./component/HomeSearch.js";
import SearchDetails from "./component/SearchDetails.js";

function App() {
  return (
    <div className="App">
      <Provider store={store}>
        <persistGate persistor={persistor}>
          <Router>
            <Routes>
              <Route path="/" element={<HomeSearch />} />
              <Route path="/searchdetails/" element={<SearchDetails />} />
            </Routes>
          </Router>
        </persistGate>
      </Provider>
    </div>
  );
}

export default App;
